import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {ProductosSubdestinosMontosActividad} from '../_models/productos-subdestinos-montos-actividad';

@Injectable({
  providedIn: 'root'
})
export class ProductosSubdestinosMontosActividadService {

  private rutaServicio = AppSettings.rutServiciosAPL + '/api/productosSubDestinosMontosActividad';
  constructor(private httClient: HttpClient,
              private autServicio: AutenticacionService) { }

  listadoHabilitados() {
    return this.httClient.get(this.rutaServicio + '/enabled').pipe(map(res => res as ProductosSubdestinosMontosActividad[]));
  }
  /**
   * Obtiene todos los registros por  idProductoSubDestinoMontoActividad
   */
  obtenerPorId(id: string) {
    return this.httClient.get(this.rutaServicio + '/' + id).pipe(map(res => res as ProductosSubdestinosMontosActividad));
  }


  filtroIdSubActividad(idProductoSubDestinoMonto: string , idActividadRelacionada: string) {
    return this.httClient.get(this.rutaServicio + '/unica/productosSubDestinosMontos/' + idProductoSubDestinoMonto + '/listasActividadesRelacionadas/' + idActividadRelacionada).pipe(map(res => res as ProductosSubdestinosMontosActividad[]));
  }

  obtenerPoridSubDestinoProducto(idSubDestinoProducto: string) {
    return this.httClient.get(this.rutaServicio + '/subDestinoProducto/' + idSubDestinoProducto + '/enabled').pipe(map(res => res as ProductosSubdestinosMontosActividad[]));
  }

  listaDestinoProductoHabilitados(idSubDestinoProducto: string) {
    return this.httClient.get(this.rutaServicio + '/destinoProducto/' + idSubDestinoProducto + '/enabled').pipe(map(res => res as ProductosSubdestinosMontosActividad[]));
  }

  listaProducto(idProducto: string) {
    return this.httClient.get(this.rutaServicio + '/producto/' + idProducto).pipe(map(res => res as ProductosSubdestinosMontosActividad[]));
  }

  listaProductoHabilitados(idProducto: string) {
    return this.httClient.get(this.rutaServicio + '/producto/' + idProducto + '/enabled').pipe(map(res => res as ProductosSubdestinosMontosActividad[]));
  }

  obtenerPorSubDestinoProductoProductoDestinoProducto(idSubDestinoProducto: string, idProducto: string, idDestinoProducto: string ) {
    return this.httClient.get(this.rutaServicio + '/subDestinoProducto/' + idSubDestinoProducto + '/producto/' + idProducto + '/destinoProducto/' + idDestinoProducto + '/enabled').pipe(map(res => res as ProductosSubdestinosMontosActividad[]));
  }

  crearSubDestinosMontosActividad( productosSubdestinosMontosActividad: ProductosSubdestinosMontosActividad ) {
    productosSubdestinosMontosActividad.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutaServicio, productosSubdestinosMontosActividad  ).pipe( map( res => res as  ProductosSubdestinosMontosActividad) );
  }

  actualizarSubDestinosMontosActividad( productosSubdestinosMontosActividad: ProductosSubdestinosMontosActividad ) {
    productosSubdestinosMontosActividad.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutaServicio, productosSubdestinosMontosActividad ).pipe( map( res => res as ProductosSubdestinosMontosActividad ) );
  }

  bulk( productosSubdestinosMontosActividad: ProductosSubdestinosMontosActividad[] ) {
    productosSubdestinosMontosActividad.map( ( s: ProductosSubdestinosMontosActividad ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutaServicio + '/bulk', productosSubdestinosMontosActividad ).pipe( map( res => res as ProductosSubdestinosMontosActividad[] ) );
  }


}
